import { render, staticRenderFns } from "./AccettazioneSsnRiepilogoImpegnativeListPage.vue?vue&type=template&id=20e7f6b3&scoped=true"
import script from "./AccettazioneSsnRiepilogoImpegnativeListPage.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnRiepilogoImpegnativeListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e7f6b3",
  null
  
)

export default component.exports